<template>
    <section class="tours-page py-9">
        <div class="tours-container container">
            <!-- Cart Items Section -->
            <div v-if="Object.keys(cartItem).length" class="selected-tours-section">
                <div class="flex-wrap">
                    <cart-item 
                        v-for="(item, tourSlotId) in cartItem" 
                        :key="tourSlotId" 
                        :item="item"
                        :first-package-id="firstPackageId"
                        @edit-package="$emit('edit-package', $event)"
                        @remove-from-cart="$emit('remove-from-cart', $event)"
                        @tab-change="$emit('tab-change', 5, 'Checkout')" />
                </div>
            </div>

            <!-- Available Tours Section -->
            <div class="available-tours-section">
                <div class="tours-grid flex flex-wrap -mx-3">
                    <available-package 
                        v-for="tourPackage in tourPackageData" 
                        :key="tourPackage.id"
                        :tour-package="tourPackage" 
                        :check-package-ids="checkPackageIds"
                        @book-now="$emit('book-now', $event)" />
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import CartItem from './CartItem.vue';
import AvailablePackage from './AvailablePackage.vue';

export default {
    name: 'InnerContentSection',
    components: {
        CartItem,
        AvailablePackage,
    },
    props: ['cartItem', 'tourPackageData', 'checkPackageIds', 'firstPackageId'],
    emits: ['edit-package', 'remove-from-cart', 'tab-change', 'book-now'],
};
</script>